import { z } from "zod";
import {
  createGetListRequestSchema,
  DomainModelMetaExtendedSchema,
  DomainModelMetaSchema,
  DomainModelSchema,
} from "../util/index.ts";
import { CustomAttributeRecordSchema } from "./CustomAttributeSchemas.ts";
import { FacilitySchema } from "./FacilitySchemas.ts";

export const EventStatus = {
  open: "open",
  overdue: "overdue",
  dismissed: "dismissed",
  resolved: "resolved",
} as const;
export type EventStatusType = (typeof EventStatus)[keyof typeof EventStatus];

export const EventSchema = z
  .object({
    company_id: z.string().uuid(),
    name: z.string(),
    description: z.string().nullable().optional(),
    status: z.nativeEnum(EventStatus),
    classification: z.string(),
    start: z.string().datetime(),
    end: z.string().datetime().nullable(),
    event_schema_id: z.string().uuid(),
    completed_at: z.string().datetime().nullable(),
    due_date: z.string().datetime().nullable(),
    associated_facility_id: z.string().uuid().nullable(),
    duration: z.string().optional(),
    associated_facility: z
      .lazy(() => FacilitySchema)
      .nullable()
      .optional(),
  })
  .merge(DomainModelSchema)
  .merge(DomainModelMetaSchema)
  .merge(DomainModelMetaExtendedSchema)
  .omit({ updated_by: true })
  .describe("Represents an Event in the Node API");
export type EventType = z.infer<typeof EventSchema>;

export const EventGetListRequestSchema = createGetListRequestSchema(
  EventSchema.pick({
    id: true,
    name: true,
    description: true,
    status: true,
    classification: true,
    start: true,
    end: true,
    event_schema_id: true,
    associated_facility_id: true,
    created_at: true,
    updated_at: true,
    due_date: true,
  })
    .merge(
      z.object({
        event_category_id: z.string().uuid(),
        "associated_facility.id": z.string().uuid(),
        "associated_facility.name": z.string(),
        "associated_facility.status": z.string(),
        "associated_facility.custom_attributes": CustomAttributeRecordSchema,
        start_window: z.string(),
        end_window: z.string(),
      })
    )
    .partial(),
  z.object({ eventSchema: z.boolean().optional() })
);
export type EventGetListRequestType = z.infer<typeof EventGetListRequestSchema>;
